<template>
  <div id="registration-screen">
    <div class="wrapper pa-0">
      <!-- Main Content -->
      <div class="page-wrapper pa-0 ma-0 auth-page">
        <div class="container">
          <!-- Row -->
          <div class="table-struct full-width full-height">
            <div class="table-cell vertical-align-middle">
              <div class="auth-form ml-auto mr-auto no-float card-view pt-30 pb-30">
                <div class="row">
                  <div class="col-sm-12 col-xs-12 center-image">
                    <img class="logo" src="static/login_logo.png">
                  </div>
                  <div class="col-sm-12 col-xs-12">
                    <div class="mb-30">
                      <h3 class="text-center txt-dark mb-10 title">{{ $t('app.registration.registrationTitle') }}</h3>
                    </div>
                    <div class="form-wrap">
											<div class="form-group">
                        <label
                          class="control-label mb-10"
                        >{{ $t('app.login.emailTitle') }}</label>
                        <base-input
                          v-model="email"
                          :type="'email'"
                          :classNames="`form-control`"
                          :required="true"
                          :placeholder="$t('app.login.emailPlaceholder')"
                          @keyup.enter.native="registrationClicked"
                        />
                      </div>
											<div class="form-group">
                        <label
                          class="control-label mb-10"
                        >{{ $t('app.registration.nameTitle') }}</label>
                        <base-input
                          v-model="name"
                          :type="'text'"
                          :classNames="`form-control`"
                          :required="true"
                          :placeholder="$t('app.registration.namePlaceholder')"
                          @keyup.enter.native="registrationClicked"
                        />
                      </div>
											<div v-if="this.$route.query.role === 'admin'" class="form-group">
                        <label
                          class="control-label mb-10"
                        >{{ $t('app.users.attributes.partner_name') }}</label>
                        <base-input
                          v-model="partnerName"
                          :type="'text'"
                          :classNames="`form-control`"
                          :required="true"
                          :disabled="true"
                          :placeholder="$t('app.users.attributes.partner_name')"
                          @keyup.enter.native="registrationClicked"
                        />
                      </div>
											<div class="form-group">
                        <label
                          class="control-label mb-10"
                        >{{ $t('app.registration.userNameTitle') }}</label>
                        <base-input
                          v-model="userName"
                          :type="'text'"
                          :classNames="`form-control`"
                          :required="true"
                          :placeholder="$t('app.registration.userNamePlaceholder')"
                          @keyup.enter.native="registrationClicked"
                        />
                      </div>
                      <div class="form-group">
                        <label
                          class="control-label mb-10"
                        >{{ $t('app.login.passwordTitle') }}</label>
                        <base-input
                          ref="password"
                          v-model="password"
                          :type="'password'"
                          :classNames="`form-control`"
                          :required="true"
                          :placeholder="$t('app.login.passwordPlaceholder')"
                           @keyup.enter.native="registrationClicked"
                        />
                      </div>
                      <div class="form-group">
                        <label
                          class="control-label mb-10"
                          for="exampleInputEmail_2"
                        >{{ $t('app.login.confirmPasswordTitle') }}</label>
                        <base-input
                          v-model="confirmedPassowrd"
                          :type="'password'"
                          :classNames="`form-control`"
                          :required="true"
                          :placeholder="$t('app.login.confirmPasswordPlaceholder')"
                          @keyup.enter.native="registrationClicked"
                        />
                      </div>
                      <div class="form-group text-center">
                        <base-button
                          :title="$t('app.registration.registrationButton')"
                          :classNames="`btn btn-orange btn-rounded`"
                          @clicked="registrationClicked"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Row -->
        </div>
      </div>
      <!-- /Main Content -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import BaseInput from '@/components/shared/inputs/BaseInput';
import BaseButton from '@/components/shared/buttons/BaseButton';
import Notification from '@/components/shared/notifications/Notification';

export default {
  name: 'LoginScreen',
  components: {
    'base-input': BaseInput,
    'base-button': BaseButton,
    notification: Notification,
  },
  data() {
    return {
      email: '',
      name: '',
      userName: '',
      password: '',
      confirmedPassowrd: '',
      partnerName: undefined
    };
  },
  created() {
    this.$i18n.locale = 'hu_HU';
    if (this.$route.query.name) {
      this.name = this.$route.query.name;
    }
    if (this.$route.query.partner) {
      this.partnerName = this.$route.query.partner;
    }
    this.email = this.$route.query.email;
  },
  methods: {
    ...mapActions({
      registration: 'users/registration',
    }),
    registrationClicked() {

      if (this.password !== '' && this.password === this.confirmedPassowrd) {
        this.registration({ invitationCode: this.$route.params.invitationCode,
          params: {
            email: this.email,
            name: this.name,
            user_name: this.userName,
            password: this.password,
            partner_name: this.partnerName,
          },
          language: this.$route.query.lang })
          .then(() => {
            this.$eventBus.showNotification({
              notificationText: this.$t('app.notifications.registrationSuccessFull'),
              notificationType: 'success',
            });
            this.$router.push({ path: '/login' });
          })
          .catch((error) => {
            this.$swal
              .fire({
                html: error[0],
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      } else {
        this.$eventBus.showNotification({
          notificationText: this.$t('app.errors.passwordConfirmation'),
          notificationType: 'danger',
        });
      }
    },
  },
};
</script>

<style lang="scss">
#registration-screen {
  height: 100%;
  .wrapper {
    height: 100%;
  }

  .center-image {
    display: flex;
    justify-content: center;
  }
  .logo {
    max-height: 205px;
  }

  .title {
    color: #808080 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/authentication/RegistrationScreen.vue